//Created by wangshuyi on 27/02/2018.

'use strict';
import VueCookies from 'vue-cookies';
import apiUtil from '@/apiUtil/apiUtil';
import RouterUtil from '@/router/RouterUtil';

export default {
  init(state) {
    if (sessionStorage.getItem(state.cookieName)) {
      let session = JSON.parse(sessionStorage.getItem(state.cookieName)), key;
      for (key in session) {
        if (!/loading|checkLang/.test(key)) {
          state[key] = session[key];
        }
      }
      RouterUtil.addAccessRoute();
    }
  },
  session(state) {
    sessionStorage.setItem(state.cookieName, JSON.stringify(state));
  },

  clearUserInfoAndToken(state) {
    state.userInfo = null;
    state.token = null;
    VueCookies.remove(state.cookieName, '/');
    this.commit('session');
  },

  // 登陆后处理返回数据
  afterLogin(state, loginReData) {
    const { userInfo, menuList, menuTree, fileList , sysList ,cityList, auth} = apiUtil.handleUserData(loginReData);  // 处理人员数据
    state.menuList = menuList;
    state.fileList = fileList;
    state.sysList = sysList;
    state.menuTree = menuTree;
    state.userInfo = userInfo;
    state.auth = auth;
    state.userInfo.cityList = cityList
    RouterUtil.addAccessRoute();
    state.token = userInfo.USER_ID;
    state.adminFlag = Boolean(userInfo.role && userInfo.role.find(r => r._id === 'admin'));
    if(userInfo?.OPER_STATUS === 20031003 && userInfo?.COMPANY_ID){
      state.companyCheckFlag = true;
    }else {
      state.companyCheckFlag = false;
    }
    //TODO 等后台返回rule_ID
    if(userInfo.USER_NAME === '游客'){
      state.isVisitor = true;
    }else {
      state.isVisitor = false;
    }
    const indexMenu = { ASSEMBLY: '/index', MENU_NAME: '首页', MENU_ID: 9898 };
    state.menuActive = indexMenu;
    state.menuTab = [indexMenu];

    this.commit('session');
  },

  isVisitor(state, isVisitor) {
    state.isVisitor = isVisitor;
    this.commit('session');
  },

  saveUserInfo(state, userInfo) {
    state.userInfo = userInfo;
    state.adminFlag = Boolean(userInfo.role && userInfo.role.find(r => r._id === 'admin'));
    this.commit('session');
  },

  saveOpenId(state, openId) {
    state.openId = openId;
    this.commit('session');
  },

  addMenuTab(state, menu) {
    const index = state.menuTab.findIndex(m => m.ASSEMBLY === menu.ASSEMBLY);
    if (index === -1) state.menuTab.push(menu);
    this.commit('session');
  },
  removeMenuTab(state, menuId) {
    const index = state.menuTab.findIndex(m => m.MENU_ID === menuId);
    if (index !== -1) state.menuTab.splice(index, 1);
    this.commit('session');
  },
  removeOtherMenuTab(state, menuId) {
    const res = [];
    state.menuTab.forEach(m => {
      if (m.MENU_ID === menuId || m.ASSEMBLY === '/index') res.push(m);
    });
    state.menuTab = res;
    this.commit('session');
  },
  // 页面tab改变sort时触发，同时改变数据的sort
  tabSortChange(state, { oldIndex, newIndex }) {
    const item = state.menuTab.splice(oldIndex, 1);
    state.menuTab.splice(newIndex, 0, item[0]);
    this.commit('session');
  },
  setActiveMenu(state, menu) {
    state.menuActive = menu;
    this.commit('session');
  },

  saveToken(state, token) {
    state.token = token;
    this.commit('session');
  },
  saveCookie(state) {
    if (state.token) {
      VueCookies.set(state.cookieName, state.token, 60 * 60 * 24 * 7, '/');
    }
  },
  setLoading(state, flag) {
    state.loading = flag;
    this.commit('session');
  },
  checkLang(state) {
    state.checkLang = true;
    this.commit('session');
  },
};
